import { render, staticRenderFns } from "./ErpUser.vue?vue&type=template&id=58ef3926&scoped=true&"
import script from "./ErpUser.vue?vue&type=script&lang=js&"
export * from "./ErpUser.vue?vue&type=script&lang=js&"
import style0 from "./ErpUser.vue?vue&type=style&index=0&id=58ef3926&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58ef3926",
  null
  
)

export default component.exports